export default "__VITE_ASSET__JeQNNGsT__"